import {
  Component,
  DestroyRef,
  inject,
  input,
  NgZone,
  signal,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CommonModule } from "@angular/common";
import { AnalogClockComponent } from "src/app/components/analog-clock/analog-clock.component";
import { ResourceService } from "src/app/services/resources/resource.service";

export type ClockType = "analog" | "digital" | "none";

@Component({
  selector: "app-screen-saver-right-content",
  templateUrl: "./screen-saver-right-content.component.html",
  styleUrl: "./screen-saver-content.component.scss",
  standalone: true,
  imports: [CommonModule, AnalogClockComponent],
})
export class ScreenSaverRightContentComponent {
  private readonly resourceService = inject(ResourceService);
  private readonly ngZone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);

  digitalClockColor = input("#00CA65");

  readonly clockType = signal<ClockType>("digital");
  readonly digitalClockTime = signal("");

  private timeInterval: any;

  constructor() {
    this.initSubscriptions();
    this.startClock();

    this.destroyRef.onDestroy(() => clearInterval(this.timeInterval));
  }

  private initSubscriptions() {
    this.resourceService.resource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((resource) => {
        this.clockType.set(
          (resource?.settings?.screenSaver?.clockType as ClockType) ?? "digital"
        );
      });
  }

  private startClock() {
    this.updateTime();
    this.ngZone.runOutsideAngular(() => {
      this.timeInterval = setInterval(() => {
        this.ngZone.run(() => this.updateTime());
      }, 1000);
    });
  }

  private updateTime() {
    const now = new Date();
    this.digitalClockTime.set(
      now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    );
  }
}
